<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5306 18.4945L18.5306 21.4945C18.4609 21.5642 18.3782 21.6195 18.2871 21.6573C18.1961 21.695 18.0985 21.7145 17.9999 21.7145C17.9014 21.7145 17.8038 21.695 17.7127 21.6573C17.6217 21.6195 17.539 21.5642 17.4693 21.4945L14.4693 18.4945C14.3286 18.3538 14.2495 18.1629 14.2495 17.9639C14.2495 17.7648 14.3286 17.574 14.4693 17.4332C14.61 17.2925 14.8009 17.2134 14.9999 17.2134C15.199 17.2134 15.3898 17.2925 15.5306 17.4332L17.2499 19.1536V13.7742L11.9999 8.52418L6.74993 13.7742V19.1536L8.4693 17.4332C8.61003 17.2925 8.80091 17.2134 8.99993 17.2134C9.19895 17.2134 9.38982 17.2925 9.53055 17.4332C9.67128 17.574 9.75035 17.7648 9.75035 17.9639C9.75035 18.1629 9.67128 18.3538 9.53055 18.4945L6.53055 21.4945C6.4609 21.5642 6.37818 21.6195 6.28713 21.6573C6.19609 21.695 6.09849 21.7145 5.99993 21.7145C5.90137 21.7145 5.80377 21.695 5.71272 21.6573C5.62168 21.6195 5.53896 21.5642 5.4693 21.4945L2.4693 18.4945C2.39962 18.4248 2.34435 18.3421 2.30663 18.251C2.26892 18.16 2.24951 18.0624 2.24951 17.9639C2.24951 17.8653 2.26892 17.7677 2.30663 17.6767C2.34435 17.5857 2.39962 17.5029 2.4693 17.4332C2.61003 17.2925 2.80091 17.2134 2.99993 17.2134C3.09847 17.2134 3.19606 17.2329 3.2871 17.2706C3.37815 17.3083 3.46087 17.3636 3.53055 17.4332L5.24993 19.1536V13.4639C5.24985 13.3653 5.26919 13.2678 5.30683 13.1767C5.34447 13.0857 5.39968 13.0029 5.4693 12.9332L11.2499 7.15355V2.96387C11.2499 2.76495 11.3289 2.57419 11.4696 2.43354C11.6103 2.29288 11.801 2.21387 11.9999 2.21387C12.1988 2.21387 12.3896 2.29288 12.5303 2.43354C12.6709 2.57419 12.7499 2.76495 12.7499 2.96387V7.15355L18.5306 12.9332C18.6002 13.0029 18.6554 13.0857 18.693 13.1767C18.7307 13.2678 18.75 13.3653 18.7499 13.4639V19.1536L20.4693 17.4332C20.61 17.2925 20.8009 17.2134 20.9999 17.2134C21.199 17.2134 21.3898 17.2925 21.5306 17.4332C21.6713 17.574 21.7503 17.7648 21.7503 17.9639C21.7503 18.1629 21.6713 18.3538 21.5306 18.4945Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsArrowSplit'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
